<template>
    <div class="grid-box-fc">
        <div class="sp-card">
            <div id="office1" style="width:100%;height:400px;">
            </div>
            <el-date-picker
                class="filter-box"
                style="width:240px"
                v-model="dp1"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="mini"
                @change="getInfo"
            >
            </el-date-picker>
        </div>
        <div class="sp-card">
            <!-- <template #header>
                <div style="display:flex;justify-content: space-between;">
                    <div style="display:flex;">
                        <div class="cl"></div>
                        <span class="headtitle">工时统计</span>
                    </div>
                </div>
            </template> -->
            <div id="office2" style="width:100%;height:400px;">
            </div>
            <el-date-picker
            class="filter-box"
                style="width:240px"
                v-model="dp2"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="mini"
                @change="getInfo2"
            >
            </el-date-picker>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    props:{
    },
    data(){
        return{
            element:{
            },
            chartList:[null,null],
            isShowPage:false,
            dp1:[],
            dp2:[],
        }
    },
    methods:{
        setResize(){
            this.chartList.forEach(e=>{
                if(e){ e.resize(); }
            })
        },
        init:function(){
            this.isShowPage = true;
            this.$api.newGetSalary().then(res=>{
                let settlement = res.data.data.settlement;
                let start = '';
                let end = '';
                let d2 = new Date();
                if(settlement>0){
                    d2.setDate(settlement);
                    end = this.$common.dayformat(d2);
                    d2.setMonth(d2.getMonth()-1);
                    d2.setDate(d2.getDate()+1);
                    start = this.$common.dayformat(d2);
                }else{
                    d2.setDate(1);
                    start = this.$common.dayformat(d2);
                    d2.setMonth(d2.getMonth()+1);
                    d2.setDate(0);
                    end = this.$common.dayformat(d2);
                }
                if(this.dp1&&this.dp1.length!=2){
                this.dp1 = [start,end];
                }
                if(this.dp2&&this.dp2.length!=2){
                    this.dp2 = [start,end];
                }
                this.getInfo();
                this.getInfo2()
            })
        },
        close:function(){
            this.chartList.forEach(e=>{
                if(e&&(!e.isDisposed)){
                    e.dispose();
                }
            })
            this.isShowPage = false;
        },
        getMyChart:function(key){
            let myChart = this.chartList[key];
            if(!myChart){
                if(this.isShowPage){
                    myChart = echarts.init(document.getElementById('office'+(key+1)))
                    this.chartList[key] = myChart;
                }
            }else{
                myChart.clear();
            }
            return myChart;
        },
        getInfo:function(){
            let obj = {
                start:'',
                end:'',
            }
            if(this.dp1&&this.dp1.length==2){
                obj.start = this.dp1[0];
                obj.end = this.dp1[1];
            }else{
                let dd = new Date();
                dd.setDate(1);
                obj.start = this.$common.dayformat(dd);
                dd.setMonth(dd.getMonth()+1);
                dd.setDate(0);
                obj.end = this.$common.dayformat(dd);
            }
            this.$api.getDailyStatistics(obj).then(res=>{
                let itemList = res.data.data;
                let myChart = this.getMyChart(0);
                if(myChart){
                    let option = {
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "shadow"
                            }
                        },
                        color:[
                            "#2EC7C9",
                            "#3E77FA",
                            "#FFB980",
                            "#FF005A",
                        ],
                        title:{
                            text:'考勤统计',
                            left:'left',
                        },
                        legend: {},
                        grid: {
                            top: '20%',
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            data: itemList.map(e=>e.carddate),
                        },
                        yAxis: {
                            type: 'value',
                            splitNumber:5,
                            name: '单位:（次）',
                        },
                        series: [{
                            name: '旷工',
                            type: 'bar',
                            stack: 'Ad',
                            emphasis: {
                                focus: 'series'
                            },
                            data: itemList.map(e=>e.abs),
                        },{
                            name: '请假',
                            type: 'bar',
                            stack: 'Ad',
                            emphasis: {
                                focus: 'series'
                            },
                            data: itemList.map(e=>e.leave),
                        },{
                            name: '迟到',
                            type: 'bar',
                            stack: 'Ad',
                            emphasis: {
                                focus: 'series'
                            },
                            data: itemList.map(e=>e.late),
                        },{
                            name: '早退',
                            type: 'bar',
                            stack: 'Ad',
                            emphasis: {
                                focus: 'series'
                            },
                            data: itemList.map(e=>e.early),
                        },]
                    };
                    myChart.setOption(option);
                }
            })
        },
        getInfo2:function(){
            let obj = {
                start:'',
                end:'',
            }
            if(this.dp1&&this.dp1.length==2){
                obj.start = this.dp1[0];
                obj.end = this.dp1[1];
            }else{
                let dd = new Date();
                dd.setDate(1);
                obj.start = this.$common.dayformat(dd);
                dd.setMonth(dd.getMonth()+1);
                dd.setDate(0);
                obj.end = this.$common.dayformat(dd);
            }
            this.$api.newGetAttendanceStatistics(obj).then(res=>{
                let dd = res.data.data.data.filter(e=>e.worktime>0);
                let myChart = this.getMyChart(1);
                if(myChart){
                    let option = {
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "shadow"
                            }
                        },
                        title:{
                            text:'工时统计',
                            left:'left',
                        },
                        legend: {},
                        grid: {
                            top:'20%',
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            data: dd.map(e=>e.ename),
                        },
                        yAxis: {
                            type: 'value',
                            splitNumber:5,
                            name: '单位:（秒）',
                        },
                        series: [{
                            name: '加班时长',
                            type: 'bar',
                            stack: 'Ad',
                            emphasis: {
                                focus: 'series'
                            },
                            data: dd.map(e=>e.wovertime+e.rovertime+e.fovertime),
                        },{
                            name: '工作时长',
                            type: 'bar',
                            stack: 'Ad',
                            emphasis: {
                                focus: 'series'
                            },
                            data: dd.map(e=>e.worktime),
                        },]
                    };
                    myChart.setOption(option);
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.grid-box-fc{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
}
</style>